import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'ContentViewPlan';

  static fields = {
    id: attr(),
    year: attr(),
    month: attr(),
    photo: attr(),
    video: attr(),
    caseCount: attr(),
    values: attr(),
    pointSistemId: fk({
      to: 'PointSystem',
      as: 'pointSystem',
      relatedName: 'contentViewPlans',
    }),
  };

  static reducer({ type, payload }, ContentViewPlan) {
    const normalize = (item) => {
      if (item && item.pointSystemId && !item.pointSistemId) {
        return {
          ...item,
          pointSistemId: item.pointSystemId,
        };
      }
      return item;
    };

    switch (type) {
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        ContentViewPlan.all().delete();

        if (payload.contentViewPlans) {
          payload.contentViewPlans.forEach((contentViewPlan) => {
            ContentViewPlan.upsert(normalize(contentViewPlan));
          });
        }

        break;
      case ActionTypes.CORE_INITIALIZE:
        if (payload.contentViewPlans) {
          payload.contentViewPlans.forEach((contentViewPlan) => {
            ContentViewPlan.upsert(normalize(contentViewPlan));
          });
        }

        break;
      case ActionTypes.CONTENT_VIEW_PLANS_FETCH__SUCCESS: {
        // Сбрасываем старые планы для pointSystemId, чтобы избежать устаревших данных
        if (payload.pointSystemId) {
          ContentViewPlan.filter({ pointSistemId: payload.pointSystemId }).delete();
        }

        payload.items.forEach((contentViewPlan) => {
          ContentViewPlan.upsert(normalize(contentViewPlan));
        });

        break;
      }
      case ActionTypes.CONTENT_VIEW_PLAN_GET_OR_CREATE__SUCCESS:
      case ActionTypes.CONTENT_VIEW_PLAN_UPDATE__SUCCESS:
        ContentViewPlan.upsert(normalize(payload.item));

        break;
      case ActionTypes.CONTENT_TYPE_TEMPLATE_APPLY__SUCCESS: {
        if (payload.pointSystemId) {
          const targetPointSystemId = String(payload.pointSystemId);
          ContentViewPlan.all()
            .toModelArray()
            .filter((item) => String(item.pointSistemId) === targetPointSystemId)
            .forEach((item) => item.delete());
        }
        (payload.contentViewPlans || []).forEach((contentViewPlan) => {
          ContentViewPlan.upsert(normalize(contentViewPlan));
        });

        break;
      }
      case ActionTypes.CONTENT_TYPE_TEMPLATE_DELETE__SUCCESS:
        (payload.contentViewPlans || []).forEach((contentViewPlan) => {
          ContentViewPlan.upsert(normalize(contentViewPlan));
        });
        break;
      default:
    }
  }
}

